export enum AnalyticsLastNMonthsRange {
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
}

export type AnalyticsPeriodFilter = AnalyticsLastNMonthsRange | null;

export interface MonthlyRevenuePoint {
  monthKey: string;
  monthLabel: string;
  total: number;
}

export interface BusinessRevenueAnalytics {
  total: number;
  monthlyTotals: MonthlyRevenuePoint[];
}
